import AGREGAR_ADJUDICACION_DIRECTA from '@/graphql/mutations/administracion/adjudicaciones/agregarAdjudicacionDirecta.gql';
import REMOVER_ADJUDICACION_DIRECTA from '@/graphql/mutations/administracion/adjudicaciones/removerAdjudicacionDirectaObra.gql';
import ADJUDICACIONES_DIRECTAS from '@/graphql/querys/administracion/adjudicaciones/adjudicacionesDirectas.gql';
import CONTRATISTAS from '@/graphql/querys/administracion/catalogos/contratistas/contratistas.gql';

export default {
  apollo: {
    contratistas: {
      query: CONTRATISTAS,
    },
  },
  methods: {
    async mixAgregarAdjudicacionDirecta() {
      const { porcentajeIva } = this.adjudicacionDirecta;
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Formato de las obras seleccionadas
      this.adjudicacionDirecta.obras = this.obrasSelected.map(({ id, importe }) => ({
        idObra: id,
        importe,
        porcentajeIva,
        iva: (importe * (porcentajeIva / 100)),
        total: (importe * ((porcentajeIva / 100 + 1))),
      }));

      await this.$apollo.mutate({
        mutation: AGREGAR_ADJUDICACION_DIRECTA,
        variables: {
          adjudicacionDirecta: this.adjudicacionDirecta,
        },
        update: (store, { data: { agregarAdjudicacionDirecta } }) => {
          const data = store.readQuery({ query: ADJUDICACIONES_DIRECTAS });
          data.adjudicacionesDirectas.push(agregarAdjudicacionDirecta);
          store.writeQuery({ query: ADJUDICACIONES_DIRECTAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarAdjudicacionDirecta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_ADJUDICACION_DIRECTA,
        variables: {
          id: this.adjudicacionDirectaEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: ADJUDICACIONES_DIRECTAS });
          const { adjudicacionesDirectas } = data;
          const index = adjudicacionesDirectas
            .findIndex((adjudicacionDirecta) => adjudicacionDirecta.id
            === this.adjudicacionDirectaEliminar.id);
          if (index !== -1) {
            adjudicacionesDirectas.splice(index, 1);
          }
          store.writeQuery({ query: ADJUDICACIONES_DIRECTAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
